
import React, {useEffect, useRef, useState} from 'react'
import { UploadVideoToS3 } from './UploadVideoToS3';
import { useQuery, useMutation } from '@apollo/client';
import { GET_AVATAR_USER_MANAGE } from '../graphql-client/Queries';
import { PUBLISH_USER } from '../graphql-client/Mutation';
export default function ComponentUploadVideoToS3({ formState, setFormState, onUploadStatusChange }) {
    const [file, setFile] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [process, setProcess] = useState(0);
    const [updateMonthlyUploadSize] = useMutation(PUBLISH_USER);
    const {data} = useQuery(GET_AVATAR_USER_MANAGE)
    const userId = data && data.userManage && data.userManage.id
    const uploadStatusChangeRef = useRef(onUploadStatusChange);

    useEffect(() => {
        uploadStatusChangeRef.current = onUploadStatusChange;
    }, [onUploadStatusChange]);

    useEffect(() => {
        uploadStatusChangeRef.current?.(isLoading);
    }, [isLoading]);
     // ✅ Video specifications config
    const VIDEO_CONFIG = {
        maxSize: 512, // MB
        maxBitrate: 6000, // kbps
        recommendedBitrate: 5000, // kbps
        supportedFormats: ['MP4'],
        quality: {
            hd: {
                label: 'HD (720p)',
                resolution: '1280x720',
                bitrate: '2500-5000 kbps',
                icon: 'fas fa-film text-primary'
            },
            fullhd: {
                label: 'Full HD (1080p)',
                resolution: '1920x1080',
                bitrate: '5000-8000 kbps',
                icon: 'fas fa-video text-success'
            },
            '4k': {
                label: '4K (2160p)',
                resolution: '3840x2160',
                bitrate: '35000-45000 kbps',
                icon: 'fas fa-desktop text-warning',
                note: 'Không khuyến nghị (quá nặng)'
            }
        }
    };
    const handleUploadVideo = async () => {
        if (!file) {
            alert('Vui lòng chọn một file trước khi tải lên.');
            return;
        }
        
        // Tính kích thước file trước khi upload
        const fileSize = file.size / (1024 * 1024);
    
        if (data?.userManage?.monthlyUploadSize > 0 && fileSize < data.userManage.monthlyUploadSize && fileSize < 512) {
            await UploadVideoToS3(file, setFile, formState, setFormState, setIsLoading, setProcess, userId);
            await handleUpdateMonthlyUploadSize(fileSize);
        } else {
            alert('Dung lượng tải lên trong tháng không đủ hoặc video vượt quá 512MB.');
        }
    };

      const handleFileVideoSelect = (e) => {
        const selectedFile = e.target.files[0];
    
        if (!selectedFile) return;
    
        // Kiểm tra nếu file có phải video không
        if (!selectedFile.type.startsWith("video/")) {
            alert("Chỉ hỗ trợ upload video.");
            return;
        }

        // Kiểm tra kích thước file phải nhỏ hơn 500MB
        const fileSizeMB = selectedFile.size / (1024 * 1024);
        if (fileSizeMB >= 512) {
            alert(`Kích thước video ${fileSizeMB.toFixed(2)}MB vượt quá giới hạn 512MB. Vui lòng chọn video nhỏ hơn.`);
            e.target.value = "";
            return;
        }

        setFile(selectedFile);
        //Tạo URL tạm cho video
        const videoURL = URL.createObjectURL(selectedFile);
         // Đọc metadata để lấy thời lượng video
        const video = document.createElement("video");
        video.preload = "metadata";

        // Đợi metadata load xong
        video.onloadedmetadata = () => {
            // Kiểm tra lại dung lượng file trong metadata callback
            const fileSizeMB = selectedFile.size / (1024 * 1024);
            if (fileSizeMB >= 500) {
                alert(`Kích thước video ${fileSizeMB.toFixed(2)}MB vượt quá giới hạn 500MB. Vui lòng chọn video nhỏ hơn.`);
                e.target.value = "";
                URL.revokeObjectURL(videoURL);
                return;
            }

            const duration = video.duration; // Thời lượng video (giây)
            const fileSizeBits = selectedFile.size * 8; // Chuyển bytes sang bits
            const bitrate = fileSizeBits / duration / 1000; // Bitrate tính bằng kbps
            
            // Kiểm tra nếu bitrate vượt quá 6000 kbps
            if (bitrate > 6000) {
                alert(`Cảnh báo: Video của bạn có bitrate ${bitrate.toFixed(2)} kbps, vượt quá mức khuyến cáo (6000 kbps). Hãy giảm tốc độ bit của video xuống.`);
                // setFile(null)
                e.target.value = ""; 
                URL.revokeObjectURL(videoURL); // Giải phóng URL trước khi return
                return;
            }

            // Giải phóng URL sau khi lấy xong metadata
            URL.revokeObjectURL(videoURL);

            // Lưu file vào state
            setFile(selectedFile);
        };

        //Đặt src sau khi gán sự kiện để đảm bảo `onloadedmetadata` được kích hoạt
        video.src = videoURL;
    };
    const handleUpdateMonthlyUploadSize = async (fileSize) => {
        try {
            await updateMonthlyUploadSize({ variables: { monthlyUploadSize: Math.round(fileSize) } });
        } catch (error) {
            console.error("Lỗi khi cập nhật dung lượng upload:", error);
        }
    };
    
  return (
    <div className='p-2'>

        {/* Quality Recommendations */}
                        {/* Technical Specs */}
                        <div className="alert alert-info  border mb-2">
                            <small>
                                <div className="row g-2">
                                    <div className="col-md-6">
                                        <i className="fas fa-hdd text-primary me-1"></i>
                                        <strong>Kích thước tối đa:</strong> {VIDEO_CONFIG.maxSize} MB
                                    </div>
                                    <div className="col-md-6">
                                        <i className="fas fa-tachometer-alt text-success me-1"></i>
                                        <strong>Bitrate khuyến nghị:</strong> {'<'} {VIDEO_CONFIG.recommendedBitrate.toLocaleString()} kbps
                                    </div>
                                    <div className="col-md-6">
                                        <i className="fas fa-file-video text-info me-1"></i>
                                        <strong>Định dạng:</strong> {VIDEO_CONFIG.supportedFormats.join(', ')}
                                    </div>
                                    <div className="col-md-6">
                                        <i className="fas fa-compress text-warning me-1"></i>
                                        <strong>Codec khuyến nghị:</strong> H.264 / H.265
                                    </div>
                                </div>
                            </small>
                        </div>

        {
                !formState.url 
                ?<div className="d-flex justify-content-between">
                    <input type="file" title='tải lên video' accept="video/*" onChange={handleFileVideoSelect} />
                    {
                        file && !process && 
                        <div className='pe-3'>
                            <button onClick={handleUploadVideo} className='' 
                            disabled={isLoading || !!formState.url}>
                                Tải lên
                            </button>
                        </div>
                    }
                </div>
                :
                (
                    formState.url && 
                    <>
                    {/* {handleUpdateMonthlyUploadSize()} */}
                    <div className="alert d-flex flex-column align-items-center" role="alert" >
                        <video className='isVideoDownload' controls src={formState.url}></video>
                        <div>
                            Đã tải lên Video, hãy tiếp tục hoàn thiện chi tiết tài liệu
                        </div>
                    </div>
                    </>
                    
                )
        }
              { 
              isLoading && 
              <div className="progress mt-2">
                    <div className="progress-bar" role="progressbar" style={{width: process+'%'}} 
                    aria-valuenow={process} aria-valuemin={0} aria-valuemax={100}
                    >
                        {process}%
                    </div>
                </div>}
        
    </div>
  )
}
